export var tokenKeyName = 'jwt';
export var jwtTokenLocalStorage = typeof localStorage !== 'undefined' ? localStorage.getItem(tokenKeyName) : '';